import { Link } from 'react-router-dom';
// import { strToolName, strVersion, strToolNameHeadlines } from '../Consts';
import { Offcanvas, Button, Collapse, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { linkOESDGSE, default_tooltip_hide, default_tooltip_show } from '../Consts';
import { openNewTabWithChecklist } from '../Functions';
import './Navigation.css';

const packageJson = require('../../../package.json');
// export function Navigation(props) {
const Navigation = ({ parentState, backCallerHandleToggleOffCanvas, backCallerHandleCollapse, backCallerHandleReset }) => {
    const areExamsLoaded = parentState.klassenarbeiten.length > 0;

    function handleHide() {
        backCallerHandleToggleOffCanvas();
        var wrapper = document.querySelector('.move-right');
        var toggleIconDiv = document.getElementById('toggle-icon-div');
        wrapper.classList.remove('offcanvas-open');
        setTimeout(function () {
            toggleIconDiv.classList.remove('oc-open');
            toggleIconDiv.classList.add('oc-close');
        }, 50);
    }

    const openWindowNewSite = (site) => {
        if (site === 'dgse') {
            window.open(linkOESDGSE, '_blank');
        }
        if (site === 'dp') {
            window.open('/?open=dp', '_blank');
        }
        if (site === 'imprint') {
            window.open('/?open=imprint', '_blank');
        }
    }

    // const handleReset = () => {
    //     const ret = {
    //         header: "Wollen Sie das Werkzeug wirklich zurücksetzen?",
    //         body: "Alle Ihre Daten gehen dabei verloren. Diese Aktion kann nicht rückgängig gemacht werden.",
    //         footer_cancel: "Abbrechen",
    //         footer_confirm: "Zurücksetzen",
    //         // method_confirm: null,
    //         visible: true,
    //     }
    //     backCallerHandleReset(ret);
    // }

    return (
        // <div className="bg-light mt-5 offcanvas offcanvas-start show" tabIndex="-1" id="offcanvasNavbar" data-bs-scroll="true"
        //     aria-labelledby="offcanvasExampleLabel">
        //     <div className="pt-0 mt-0 offcanvas-body">
        //         <div id="dgse-nav-container" className="flex-shrink-0 p-3 pb-0 bg-white">
        //             <div className="d-flex w-100">
        //                 <span className="fs-5 fw-semibold border-bottom w-100">Navigation</span>
        //                 <i className="fw-bold bi bi-chevron-double-left pe-2" data-bs-dismiss="offcanvas"
        //                     aria-label="Close"></i>
        //             </div>
        //             <ul className="list-unstyled pt-2 m-0">
        //                 <li className="mb-1 my-3">
        //                     <a href="/erfassung">
        //                         <button className="btn btn-toggle align-items-center rounded collapsed">
        //                             Erfassung der Ergebnisse
        //                         </button>
        //                     </a>
        //                 </li>
        //                 <li className="mb-1 my-3">
        //                     <a href="/auswertung">
        //                         <button className="btn btn-toggle align-items-center rounded collapsed">
        //                             Auswertung und Analyse
        //                         </button>
        //                     </a>
        //                 </li>
        //                 <li className="mb-1">
        //                     <button className="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse"
        //                         data-bs-target="#dashboard-collapse" aria-expanded="false">
        //                         Dashboard
        //                     </button>
        //                     <div className="collapse" id="dashboard-collapse">
        //                         <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
        //                             <li><a href="#" className="link-dark rounded">Overview</a></li>
        //                             <li><a href="#" className="link-dark rounded">Weekly</a></li>
        //                             <li><a href="#" className="link-dark rounded">Monthly</a></li>
        //                             <li><a href="#" className="link-dark rounded">Annually</a></li>
        //                         </ul>
        //                     </div>
        //                 </li>

        //                 <li className="border-top my-3"></li>
        //                 <li className="mb-1 mb-3">
        //                     <button className="btn btn-toggle align-items-center rounded collapsed">
        //                         XXX
        //                     </button>
        //                 </li>
        //             </ul>
        //         </div>

        //         <div className="pt-2">
        //             <span className="fw-bold text-danger">Wichtiger Hinweis:</span>
        //             <br />Sie befinden sich auf einer Test-Instanz!
        //         </div>
        //     </div>
        // </div>
        <Offcanvas className="mt-5" backdrop={false} show={parentState.helper.offcanvas.show}
            scroll={true} placement="start" id="offcanvasNavbar">
            <Offcanvas.Body className="pt-0 mt-0 bg-light">
                <div id="dgse-nav-container" className="flex-shrink-0 p-3 pb-0 bg-white">
                    <div className="d-flex w-100">
                        <span className="fs-5 fw-semibold border-bottom w-100">Navigation</span>
                        <i className="fw-bold bi bi-chevron-double-left pe-2" onClick={handleHide} aria-label="Close"></i>
                    </div>
                    <ul className="list-unstyled pt-0 m-0">
                        <li className="mb-1 my-3">
                            <a href="/" className="">
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0 icon-back">
                                    Zurück zur Tool-Auswahl
                                </Button>
                            </a>
                        </li>
                        <li className="border-top my-3"></li>

                        <li className="mb-1 my-3">
                            <Link to="/auswertung/klassenarbeiten">
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={<Tooltip className="navigation-tooltip"
                                        id="tooltipNavExams">Lokal gespeicherte Klassenarbeiten laden. Sie können nur Klassenarbeiten öffnen, welche mit dem Examer bearbeitet oder aus moodle exportiert wurden.</Tooltip>
                                    }
                                // show={parentState.helper.tooltips ? undefined : false}
                                >
                                    <Button className="btn btn-toggle align-items-center rounded collapsed border-0">
                                        Klassenarbeiten laden
                                    </Button>
                                </OverlayTrigger>
                            </Link>
                        </li>

                        <li className="mb-1 my-3">
                            <Link to={areExamsLoaded ? "/auswertung/auswertung" : "#"}>
                                <OverlayTrigger
                                    placement="right"
                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                    overlay={<Tooltip className="navigation-tooltip"
                                        id="tooltipNavEval">Klassenarbeit bzw. Klassenarbeiten analysieren.</Tooltip>
                                    }
                                // show={parentState.helper.tooltips ? undefined : false}
                                >
                                    <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                        disabled={!areExamsLoaded}>
                                        Analyse
                                    </Button>
                                </OverlayTrigger>
                            </Link>
                        </li>

                        {/* <li className="mb-1 my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavDGSE">DGSE Dokumentation erstellen und senden.</Tooltip>
                                }
                            >
                                <Button
                                    className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => backCallerHandleCollapse("navdgse")}
                                    aria-controls="collapse-nav-dgse"
                                    aria-expanded={parentState.helper.collapse.navdgse}
                                    disabled={!areExamsLoaded}
                                >
                                    DGSE
                                </Button>
                            </OverlayTrigger>
                            <Collapse in={parentState.helper.collapse.navdgse}>
                                <div id="collapse-nav-dgse">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={<Tooltip className="navigation-tooltip"
                                                    id="tooltipNavDGSEAna">Prüfkategorien und Aufmerksamkeitspunkte.</Tooltip>
                                                }
                                            // show={parentState.helper.tooltips ? undefined : false}
                                            >
                                                <Link to={areExamsLoaded ? "/auswertung/analyseschritte/dgse" : "#"}
                                                    className={`link-dark rounded ${!areExamsLoaded ? 'custom-disabled-link' : ''}`}
                                                >
                                                    Dokumentation erstellen
                                                </Link>
                                            </OverlayTrigger>

                                        </li>
                                        <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={<Tooltip className="navigation-tooltip"
                                                    id="tooltipNavDGSEExport">Dokumentation wird für die Schulentwicklung in der Datenbank gespeichert.</Tooltip>
                                                }
                                            // show={parentState.helper.tooltips ? undefined : false}
                                            >
                                                <Link to={areExamsLoaded ? "/auswertung/analyseschritte/einspielen" : "#"}
                                                    className={`link-dark rounded ${!areExamsLoaded ? 'custom-disabled-link' : ''}`}
                                                >
                                                    Dokumentation senden
                                                </Link>
                                            </OverlayTrigger>
                                        </li>
                                    </ul>
                                </div>
                            </Collapse>
                        </li> */}
                        <li className="my-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavAuSt">Analysestand der aktuellen Klassenarbeit bzw. Klassenarbeiten speichern oder laden. Sie können nur Analysestände öffnen, welche mit dem Examer bearbeitet wurden.</Tooltip>
                                }
                            // show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button
                                    className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => backCallerHandleCollapse("navauswertungsstand")}
                                    aria-controls="collapse-nav-auswertungsstand"
                                    aria-expanded={parentState.helper.collapse.navauswertungsstand}
                                >
                                    Analysestand
                                </Button>
                            </OverlayTrigger>

                            <Collapse in={parentState.helper.collapse.navauswertungsstand}>
                                <div id="collapse-nav-auswertungsstand">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={<Tooltip className="navigation-tooltip"
                                                    id="tooltipNavAuStSave">Den eigenen Analysestand speichern.</Tooltip>
                                                }
                                            // show={parentState.helper.tooltips ? undefined : false}
                                            >
                                                <Link to={areExamsLoaded ? "/auswertung/auswertung/speichern" : "#"}
                                                    className={`link-dark rounded ${!areExamsLoaded ? 'custom-disabled-link' : ''}`}
                                                >
                                                    Speichern
                                                </Link>
                                            </OverlayTrigger>
                                        </li>
                                        <li>
                                            <OverlayTrigger
                                                placement="right"
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={<Tooltip className="navigation-tooltip"
                                                    id="tooltipNavAuStLoad">Den eigenen Analysestand laden.</Tooltip>
                                                }
                                            // show={parentState.helper.tooltips ? undefined : false}
                                            >
                                                <Link to="/auswertung/auswertung/laden"
                                                    className="link-dark rounded">
                                                    Laden
                                                </Link>
                                            </OverlayTrigger>
                                        </li>
                                    </ul>
                                </div>
                            </Collapse>

                        </li>

                        <li className="border-top my-3"></li>
                        <li className="mb-3">
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip"
                                    id="tooltipNavChecklist">Checkliste zur systematischen Analyse von gemeinsamen Klassenarbeiten.</Tooltip>
                                }
                            // show={parentState.helper.tooltips ? undefined : false}
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={openNewTabWithChecklist}>
                                    Checkliste
                                </Button>
                            </OverlayTrigger>
                        </li>
                        <li className="mb-3">
                            {/* <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                onClick={() => alert("In Arbeit...")}>
                                Handreichungen
                            </Button> */}
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit Informationen zur Datengestützten Schul- und Unterrichtsentwicklung (DGSE).</Tooltip>
                                }
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('dgse')}>
                                    Handreichungen
                                </Button>
                            </OverlayTrigger>

                        </li>
                        <li className="border-top my-3"></li>
                        <li className="mb-3">
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit der Datenschutzerklärung.</Tooltip>
                                }
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('dp')}>
                                    Datenschutzerklärung
                                </Button>
                            </OverlayTrigger>
                        </li>
                        <li className="mb-3">
                            <OverlayTrigger placement="right"
                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                overlay={<Tooltip className="navigation-tooltip">Es öffnet sich ein neues Fenster mit dem Impressum.</Tooltip>
                                }
                            >
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0"
                                    onClick={() => openWindowNewSite('imprint')}>
                                    Impressum
                                </Button>
                            </OverlayTrigger>
                        </li>

                        {/* <li className="border-top my-3"></li> */}
                        {/* <li className="mb-3">
                            <Button onClick={handleReset} className="btn btn-toggle align-items-center rounded collapsed border-0 icon-back">
                                Zurücksetzen
                            </Button>
                        </li> */}

                        {parentState.klassenarbeiten.length > 0 && (
                            <>
                                <li className="border-top my-3"></li>
                                {/* <li className="mb-3 my-3 ps-1"> */}
                                <li className="my-4">

                                    <Card bg="light" text="dark" border="dark">
                                        <Card.Body>
                                            <Card.Title as="h6">
                                                Klassenarbeiten: {parentState.klassenarbeiten.length}
                                            </Card.Title>
                                            <Card.Text>
                                                Aufgaben: {parentState.klassenarbeiten[0].maxPunkte[0].length - 3}
                                                <br />
                                                Maximalpunkte: {parentState.klassenarbeiten[0].maxPunkte[0][parentState.klassenarbeiten[0].maxPunkte[0].length - 1].value}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>

                                </li>
                            </>
                        )}
                        {/* <li className="mb-1 my-3">
                                <a href="/auswertung">
                                    <Button className="btn btn-toggle align-items-center rounded collapsed border-0">
                                        Auswertungsstand speichern
                                    </Button>
                                </a>
                            </li>
                            <li className="mb-1 my-3">
                                <a href="/auswertung">
                                    <Button className="btn btn-toggle align-items-center rounded collapsed border-0">
                                        Auswertungsstand laden
                                    </Button>
                                </a>
                            </li> */}
                        {/* <li className="mb-1 my-3">
                            <a href="/auswertung">
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Aktuelle Ansicht drucken
                                </Button>
                            </a>
                        </li>
                        <li className="border-top my-3"></li>

                        <li className="mb-1 mb-3">
                            <Link onClick={() => { if (window.confirm('Möchten Sie die Anwendung wirklich zurücksetzen?')) this.handleReset() }}>
                                <Button className="btn btn-toggle align-items-center rounded collapsed border-0">
                                    Zurücksetzen
                                </Button>
                            </Link>
                        </li> */}

                    </ul>
                </div>
                {/* <div className="pt-2 m-2">
                    <span className="fw-bold text-danger">Wichtiger Hinweis:</span>
                    <br />
                    Sie befinden sich auf einer Test-Instanz!
                </div> */}

                <div
                    className="position-fixed bottom-0 start-0 m-2 px-2 bg-dark text-white opacity-75 rounded"
                    style={{ fontSize: '12px', width: 'auto', textAlign: 'right' }}
                >
                    Version: {packageJson.version}
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default Navigation;